export default Route => {
  // 其他
  Route.group({ prefix: "/salary" }, () => {
    Route.view("/calculator", () =>
      import(/* webpackChunkName: "other" */ "../views/salary/calculator.vue")
    ).options({
      meta: {
        layout: "empty"
      }
    });
    Route.view("/trial", () =>
      import(/* webpackChunkName: "other" */ "../views/salary/trial.vue")
    ).options({
      meta: {
        layout: "empty"
      }
    });
  });
};
